export default "__VITE_ASSET__DZhk$Uqt__"